
import { Children, FC } from 'react'
import { stylesheet, classes } from 'typestyle'

/* Components =================================================================================== */
import AppLayout from '../layout'
import { Box } from '../../../../components/box/box.component'
import { Form } from '../../../../components/form'
import { Heading } from '../../../../components/text/heading.component'
import { Line } from '../../../../components/line'
import { Logo } from '../../../../../components/logo'
import { Text } from '../../../../components/text/text.component'

/* Styles ======================================================================================= */
import { createMediaQuery } from '../../../../components/style-class/style-class.utils'
import { mb8 } from '../../../../styles/styleset/margin/mb8'
import { paddingVerticalInner, paddingVerticalOuter } from '../../../../styles/default/padding'
import { pb16 } from '../../../../styles/styleset/padding/pb16'
import { pt16 } from '../../../../styles/styleset/padding/pt16'
import { pt20 } from '../../../../styles/styleset/padding/pt20'
import { pb20 } from '../../../../styles/styleset/padding/pb20'
import { mb16 } from '../../../../styles/styleset/margin/mb16'
import { FadeIn } from '../../../../components/fade-in'

/* <AuthenticationLayout /> ===================================================================== */
const AuthenticationLayout: FC<{ children: any; title?: string; subtitle?: string }> = ({
  children,
  title,
  subtitle,
}) => {
  return (
    <AppLayout.render
      content={
        <Box minHeight={'100vh'} baseline="none" alignCenterY alignCenterX>
          <Box
            className={classes(STYLES.mainContainer, paddingVerticalOuter)}
            baseline="background"
            row
          >
            <Logo className={mb16} toggled withSmallLogo={false} />
            <FadeIn offset={0}>
              <Box baseline="none" row fullWidth>
                <Box
                  className={classes(STYLES.container)}
                  baseline="surface"
                  shadowContrast="light"
                  centerAutoX
                  rounded
                  border
                  row
                >
                  <Box baseline="none" alignCenterY row>
                    <Box baseline="none" className={classes()} row>
                      <Box
                        baseline="none"
                        className={classes(paddingVerticalInner, pt20, pb20)}
                        row
                        alignCenterX
                      >
                        {title && (
                          <Heading className={classes(subtitle && mb8)} size="md" semiBold>
                            {title}
                          </Heading>
                        )}
                        {subtitle && (
                          <>
                            <Text baseline="surface" size="lg" lighter>
                              {subtitle}
                            </Text>
                          </>
                        )}
                      </Box>
                      <Line />
                    </Box>
                  </Box>
                  <Box baseline="none" rounded>
                    {children &&
                      Children.map(children, (item: any) => {
                        return item
                      })}
                  </Box>
                </Box>
              </Box>
            </FadeIn>
          </Box>
        </Box>
      }
    />
  )
}

export const StyledForm = (props: any) => (
  <Box baseline="none" className={classes(paddingVerticalInner, pt16, pb16)}>
    <Form {...props} className={classes(props.className, STYLES.containForm)} />
  </Box>
)

/* Typestyle ==================================================================================== */
const STYLES = stylesheet({
  container: {
    maxWidth: 380,
    minWidth: 380,
    width: '100%',
    $nest: {
      ...createMediaQuery.xs({
        minWidth: 264,
        width: '100%',
      }),
    },
  },
  containForm: {
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  },
  mainContainer: {
    alignItems: 'center',
    display: 'flex',
    $nest: {
      ...createMediaQuery.xs({
        minWidth: '100%',
        width: '100%',
      }),
    },
  },
  imageContainer: {
    alignItems: 'center',
    backgroundColor: '#AEC6CF',
    color: 'white',
    height: '100vh',
    justifyContent: 'center',
  },
  formContainer: {
    alignItems: 'center',
    backgroundColor: 'white',
    justifyContent: 'center',
  },
})

export default AuthenticationLayout
